// extracted by mini-css-extract-plugin
module.exports =  {"list":"_25d45facb5--list--EO8rV","item-wrapper":"_25d45facb5--item-wrapper--_btvn","indented":"_25d45facb5--indented--WhqXG","item":"_25d45facb5--item--SZJyk"};